// extracted by mini-css-extract-plugin
export default {"bg":"success_bg__JlT3A","btn":"success_btn__g6o70"};